import { PublishedFormId } from '@furnish-hx/constants/FormId';
import FormTypeId from '@core/constants/FormTypeId';
import fieldPortfolioData from './common/fieldsPortfolioData';
import {
    IFormFieldKey,
    IForm,
} from '../../interfaces/Form';
import fieldsContact from './common/fieldsContact';
import { IDesignProjectId, IDesignProjectCategoryId } from '../../interfaces/DesignProject';
import additionalDataFactory from './common/fieldsAdditionalData';
import budgetMarksBuilder from './common/budgetMarksBuilder';

const dpHouseOutsideForm: IForm = {
    formId       : PublishedFormId.DpHouseOutside,
    type         : FormTypeId.DesignProject,
    thumbnailURL : '/resized-images/forms/dpHouseOutside.jpg',
    fieldsOrder  : [
        IFormFieldKey.PortfolioData,
        IFormFieldKey.Comment,
        IFormFieldKey.DesignProject,
        IFormFieldKey.AdditionalData,
        IFormFieldKey.Contact,
    ],
    fields: {
        portfolioData : fieldPortfolioData,
        comment       : {
            comment: {
                value    : undefined,
                required : false,
            },
        },
        designProject: {
            [IDesignProjectCategoryId.Outside]: {
                [IDesignProjectId.WoodenDeck]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.Awning]: {
                    value : undefined,
                    min   : 0,
                    max   : 2,
                },
                [IDesignProjectId.Marquise]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.Pergola]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.Veranda]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.Fence]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.SwimmingPool]: {
                    value : undefined,
                    min   : 0,
                    max   : 1,
                },
                [IDesignProjectId.Portal]: {
                    value : undefined,
                    min   : 0,
                    max   : 1,
                },
                [IDesignProjectId.OutdoorTable]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.OutdoorChair]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.SummerKitchen]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.GlassWall]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.Separator]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.Stool]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.Bench]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
                [IDesignProjectId.Sunbath]: {
                    value : undefined,
                    min   : 0,
                    max   : 5,
                },
            },
        },
        additionalData: additionalDataFactory({
            budgetMin          : 2000,
            budgetMax          : 250000,
            budgetDefaultValue : 15000,
            marks              : budgetMarksBuilder(2000, 1000, 50000, 5000, 250000),
            hasQuantity        : false,
        }),
        contact: fieldsContact,
    },
};

export default dpHouseOutsideForm;
